export class Lazy<T> {
	private currentGetter: () => T;

	public constructor(getter: () => T) {
		const self = this;

		self.currentGetter = () => {
			const value = getter();

			self.currentGetter = () => value;

			return value;
		};
	}

	public getValue(): T {
		return this.currentGetter();
	}
}
